import { useState } from 'react';
import Cookie from 'js-cookie';

import { DEFAULT_CURRENCY_CODE, STORAGE } from 'shared/enums/SitePreferences';
import { AVAILABLE_LOCALES } from 'localization/constants/configEnums';
import { getLocale } from 'shared/utils/getLocale';

interface ICurrency {
  selectedCurrencyCode: string;
  setSelectedCurrencyCode: (val: string) => void;
}

export const useCurrency = (_locale?: string): ICurrency => {
  const locale = _locale || getLocale();
  let currencyCookie = Cookie.getJSON(STORAGE.CURRENCY);

  if (typeof currencyCookie !== 'string') {
    currencyCookie = Cookie.getJSON('currencyCode');
  }

  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState(
    currencyCookie || AVAILABLE_LOCALES[locale]?.currency || DEFAULT_CURRENCY_CODE,
  );

  return {
    selectedCurrencyCode,
    setSelectedCurrencyCode,
  };
};
